import { render, staticRenderFns } from "./Withdrawalrecord.vue?vue&type=template&id=5885f5e6&scoped=true"
import script from "./Withdrawalrecord.vue?vue&type=script&lang=js"
export * from "./Withdrawalrecord.vue?vue&type=script&lang=js"
import style0 from "./Withdrawalrecord.vue?vue&type=style&index=0&id=5885f5e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5885f5e6",
  null
  
)

export default component.exports